import React, { useState, useEffect, useRef } from "react";
import "./ReportInsights.css";
import { useNavigate } from 'react-router-dom';
import ReportsHero from "./ReportsHero";
import  SectionWiseCode from "./SectionWiseCode";
import HRCopilotFeatures from './HRCopilotFeatures';
import HRCopilotNewsSection from "./HRCopilotNewsSection";



const VideoPopup = ({ isOpen, onClose, videoUrl }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
      }
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="insights-video-popup-overlay" onClick={onClose}>
      <div className="insights-video-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="insights-video-popup-close" onClick={onClose}>
          ×
        </button>
        <div className="insights-video-container">
          <video ref={videoRef} controls autoPlay className="insights-demo-video">
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="insights-video-popup-info">
          <h3>Report Insights Platform</h3>
          <p>See how our analytics platform transforms data into actionable business intelligence</p>
        </div>
      </div>
    </div>
  );
};

const ReportInsights = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isVideoPopupOpen, setIsVideoPopupOpen] = useState(false);
  const [activeFeature, setActiveFeature] = useState(0);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [activeTab, setActiveTab] = useState("drive-business");
  const navigate = useNavigate();
    const videoRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);

  const handleAccessRecruit = () => navigate('/access-recruit');


  useEffect(() => {
    setIsVisible(true);
    
    // Auto rotate features
    const interval = setInterval(() => {
      setActiveFeature(prev => (prev + 1) % 6);
    }, 4000);
    
    // Scroll progress
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (scrollTop / docHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const demoVideoUrl = "https://assets.mixkit.co/videos/preview/mixkit-woman-analyzing-data-on-a-computer-41358-large.mp4";

  const openVideoPopup = () => {
    setIsVideoPopupOpen(true);
  };

  const closeVideoPopup = () => {
    setIsVideoPopupOpen(false);
  };


  const handleAccessAnalytics = () => navigate('/payment');


const openAnalyticsVideoPopup = () => {
  // Open analytics management video popup
  console.log("Open analytics management video");
};

  const features = [
    {
      icon: "📊",
      title: "Interactive Dashboards",
      description: "Create dynamic, real-time dashboards with drag-and-drop widgets and customizable visualizations"
    },
    {
      icon: "🤖",
      title: "AI-Powered Analytics",
      description: "Get intelligent insights, trend predictions, and automated anomaly detection with machine learning"
    },
    {
      icon: "🔄",
      title: "Automated Reporting",
      description: "Schedule and automate report generation, distribution, and delivery to stakeholders"
    },
    {
      icon: "🔍",
      title: "Advanced Data Exploration",
      description: "Drill down into data with advanced filtering, segmentation, and cross-dimensional analysis"
    },
    {
      icon: "📱",
      title: "Mobile Insights",
      description: "Access reports and dashboards on any device with responsive design and mobile-optimized views"
    },
    {
      icon: "🛡️",
      title: "Enterprise Security",
      description: "Role-based access control, data encryption, and compliance with industry regulations"
    }
  ];

 const analyticsStages = [
  {
    phase: "Ingest",
    icon: "📥",
    time: "Real-time",
    title: "Data Collection & Integration",
    steps: [
      "Multi-source data ingestion",
      "Automated data validation",
      "Real-time streaming support",
      "Schema mapping & transformation"
    ]
  },
  {
    phase: "Process",
    icon: "⚙️",
    time: "2-5 seconds",
    title: "Intelligent Data Processing",
    steps: [
      "AI-powered data cleaning",
      "Automated feature engineering",
      "Real-time data enrichment",
      "Quality assurance checks"
    ]
  },
  {
    phase: "Analyze",
    icon: "🔍",
    time: "Instant",
    title: "Advanced Analytics & ML",
    steps: [
      "Predictive modeling",
      "Anomaly detection algorithms",
      "Pattern recognition",
      "Statistical analysis"
    ]
  },
  {
    phase: "Visualize",
    icon: "📊",
    time: "Real-time",
    title: "Interactive Insights & Reporting",
    steps: [
      "Dynamic dashboard creation",
      "Interactive data exploration",
      "Automated report generation",
      "Real-time alerting system"
    ]
  }
];

const analyticsMetrics = [
  { name: "Sales Analytics", progress: 88 },
  { name: "Marketing Reports", progress: 95 },
  { name: "Financial Dashboards", progress: 82 },
  { name: "Operational Metrics", progress: 76 }
];

const analyticsIntegrations = [
  "Salesforce", "Google Analytics", "MySQL", "PostgreSQL", 
  "MongoDB", "Excel", "Google Sheets", "REST API", 
  "Snowflake", "BigQuery", "Tableau", "Power BI"
];

  const tabs = [
    {
      id: "drive-business",
      label: "DRIVE YOUR BUSINESS",
      content: {
        icon: "🚀",
        title: "Accelerate Business Growth",
        description: "Streamline operations and boost productivity with integrated business solutions that drive measurable results.",
        features: ["BUSINESS INTELLIGENCE", "WORKFLOW AUTOMATION", "PERFORMANCE ANALYTICS"],
        secondary: {
          icon: "📈",
          title: "Real-time Business Insights",
          description: "Make data-driven decisions with comprehensive dashboards and predictive analytics that forecast business trends."
        },
        buttonText: "EXPLORE BUSINESS SOLUTIONS"
      }
    },
    {
      id: "command-endpoints",
      label: "COMMAND ENDPOINTS →",
      content: {
        icon: "🖥️",
        title: "Centralized Endpoint Management",
        description: "Take complete control over all your devices from a single dashboard with real-time monitoring and automated maintenance.",
        features: ["REMOTE ACCESS", "PATCH MANAGEMENT", "ENDPOINT SECURITY"],
        secondary: {
          icon: "🔒",
          title: "Proactive Security Monitoring",
          description: "Prevent security breaches with AI-powered threat detection and automated response systems that protect your endpoints 24/7."
        },
        buttonText: "EXPLORE ENDPOINT SOLUTIONS"
      }
    },
    {
      id: "scale-seamlessly",
      label: "SCALE SEAMLESSLY",
      content: {
        icon: "📊",
        title: "Take complete control over your devices",
        description: "Maintain your endpoints in prime condition with round-the-clock monitoring, proactive management, and airtight security.",
        features: ["RMM", "NETWORK MONITORING", "ENDPOINT SECURITY"],
        secondary: {
          icon: "✨",
          title: "Unleash your spidey-sense",
          description: "Predict and prevent IT chaos with real-time monitoring, proactive patching, remote troubleshooting, and AI-based alerting."
        },
        buttonText: "EXPLORE OUR RMM"
      }
    },
    {
      id: "analyze-improve",
      label: "ANALYZE AND IMPROVE",
      content: {
        icon: "🔍",
        title: "Deep Analytics & Optimization",
        description: "Gain valuable insights into your IT infrastructure with advanced analytics and machine learning algorithms.",
        features: ["PREDICTIVE ANALYTICS", "PERFORMANCE OPTIMIZATION", "ROOT CAUSE ANALYSIS"],
        secondary: {
          icon: "📱",
          title: "Continuous Improvement",
          description: "Identify bottlenecks, optimize resources, and implement data-driven improvements across your entire IT ecosystem."
        },
        buttonText: "EXPLORE ANALYTICS TOOLS"
      }
    }
  ];

  const activeTabContent = tabs.find(tab => tab.id === activeTab)?.content;

  return (
    <div className="insights-container">
      {/* Scroll Progress Bar */}
      {/* <div className="insights-scroll-progress" style={{width: `${scrollProgress}%`}}></div> */}

      {/* Video Popup */}
      <VideoPopup 
        isOpen={isVideoPopupOpen} 
        onClose={closeVideoPopup} 
        videoUrl={demoVideoUrl}
      />

      {/* Enhanced Animated Background */}
      <div className="insights-background-animation">
        {/* <div className="insights-floating-shape insights-shape-1"></div>
        <div className="insights-floating-shape insights-shape-2"></div>
        <div className="insights-floating-shape insights-shape-3"></div>
        <div className="insights-floating-shape insights-shape-4"></div>
        <div className="insights-floating-shape insights-shape-5"></div> */}
        
        {/* Animated Gradient Orbs */}
        {/* <div className="insights-gradient-orb insights-orb-1"></div>
        <div className="insights-gradient-orb insights-orb-2"></div>
        <div className="insights-gradient-orb insights-orb-3"></div> */}
        
        {/* SVG Background Animation */}
        <svg className="insights-bg-svg" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <linearGradient id="insights-gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgba(74, 144, 226, 0.08)" />
              <stop offset="50%" stopColor="rgba(120, 119, 216, 0.05)" />
              <stop offset="100%" stopColor="rgba(226, 74, 144, 0.08)" />
            </linearGradient>
            <linearGradient id="insights-gradient2" x1="100%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="rgba(120, 119, 216, 0.06)" />
              <stop offset="50%" stopColor="rgba(119, 216, 216, 0.04)" />
              <stop offset="100%" stopColor="rgba(74, 226, 144, 0.06)" />
            </linearGradient>
            <pattern id="insights-grid" width="10" height="10" patternUnits="userSpaceOnUse">
              <path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100" height="100" fill="url(#insights-grid)" />
          <path 
            d="M0,15 Q30,5 60,25 T100,35 L100,100 L0,100 Z" 
            fill="url(#insights-gradient1)"
            className="insights-svg-path-1"
          />
          <path 
            d="M0,65 Q40,45 80,70 T100,85 L100,100 L0,100 Z" 
            fill="url(#insights-gradient2)"
            opacity="0.8"
            className="insights-svg-path-2"
          />
        </svg>
      </div>
<ReportsHero/>
<SectionWiseCode/>
<HRCopilotFeatures/>
<HRCopilotNewsSection/>



      {/* IT Platform Section with Tabs */}


   {/* Analytics Journey Timeline */}


{/* Analytics Insights Section */}


{/* Analytics Integration Ecosystem */}


{/* Analytics Management CTA */}

    </div>
  );
};

export default ReportInsights;